/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Possession actions belong to the player and team recorded in the event. Technical faults, lost balls, and legacy turnovers have separate counters. A saved attempt credits a save to the opposing team regardless of player attribution. Goals count shot events and may differ from an administratively adjusted final score.
 * @export
 * @interface MatchOperationV2TeamShotStatistics
 */
export interface MatchOperationV2TeamShotStatistics {
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2TeamShotStatistics
     */
    attempts: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2TeamShotStatistics
     */
    goals: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2TeamShotStatistics
     */
    saves: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2TeamShotStatistics
     */
    posts: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2TeamShotStatistics
     */
    blockedShots: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2TeamShotStatistics
     */
    turnovers: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2TeamShotStatistics
     */
    technicalFaults: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2TeamShotStatistics
     */
    lostBalls: number;
}

/**
 * Check if a given object implements the MatchOperationV2TeamShotStatistics interface.
 */
export function instanceOfMatchOperationV2TeamShotStatistics(value: object): value is MatchOperationV2TeamShotStatistics {
    if (!('attempts' in value) || value['attempts'] === undefined) return false;
    if (!('goals' in value) || value['goals'] === undefined) return false;
    if (!('saves' in value) || value['saves'] === undefined) return false;
    if (!('posts' in value) || value['posts'] === undefined) return false;
    if (!('blockedShots' in value) || value['blockedShots'] === undefined) return false;
    if (!('turnovers' in value) || value['turnovers'] === undefined) return false;
    if (!('technicalFaults' in value) || value['technicalFaults'] === undefined) return false;
    if (!('lostBalls' in value) || value['lostBalls'] === undefined) return false;
    return true;
}

export function MatchOperationV2TeamShotStatisticsFromJSON(json: any): MatchOperationV2TeamShotStatistics {
    return MatchOperationV2TeamShotStatisticsFromJSONTyped(json, false);
}

export function MatchOperationV2TeamShotStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchOperationV2TeamShotStatistics {
    if (json == null) {
        return json;
    }
    return {
        
        'attempts': json['attempts'],
        'goals': json['goals'],
        'saves': json['saves'],
        'posts': json['posts'],
        'blockedShots': json['blockedShots'],
        'turnovers': json['turnovers'],
        'technicalFaults': json['technicalFaults'],
        'lostBalls': json['lostBalls'],
    };
}

export function MatchOperationV2TeamShotStatisticsToJSON(json: any): MatchOperationV2TeamShotStatistics {
    return MatchOperationV2TeamShotStatisticsToJSONTyped(json, false);
}

export function MatchOperationV2TeamShotStatisticsToJSONTyped(value?: MatchOperationV2TeamShotStatistics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'attempts': value['attempts'],
        'goals': value['goals'],
        'saves': value['saves'],
        'posts': value['posts'],
        'blockedShots': value['blockedShots'],
        'turnovers': value['turnovers'],
        'technicalFaults': value['technicalFaults'],
        'lostBalls': value['lostBalls'],
    };
}

